/** @jsxImportSource @emotion/react */
"use client";

import { useTranslations } from "@i18n/react";
import { usePlayer } from "@packages/media";

import { MusicIcon } from "../../../../../components/_base/icons/Icon/GeneralIcons";
import { ModalTab } from "../../../../../components/_base/modals/ModalTab/ModalTab.emotion";
import type { MediaMenuTabProps } from "../MediaMenu/MediaMenu.emotion";

export const SelectBackgroundTab = ({ disabled }: MediaMenuTabProps) => {
  const t = useTranslations();
  const player = usePlayer();

  return (
    <ModalTab
      key={"selectBgMenuTab"}
      value={"selectBgMenu"}
      label={t("track_settings_background_sounds")}
      startIcon={<MusicIcon />}
      disabled={disabled}
    >
      {player?.bgTitle ?? t("web_audio_setting_list_option_background_none")}
    </ModalTab>
  );
};
